import { mergeConfigs } from '../app/app-config.model';
import defaultConfig from '../../conf/_default.json';
import packageConf from '../../package.json';

const appVersion: string = packageConf.version;
let envConfig = {};

try {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  envConfig = require('../../conf/_env.json');
} catch (err) {
  // just use the default
}

export const environment = {
  production: false,
  kitchenLocal: {
    urls: {
      resources: 'http://localhost:4200',
    },
  },
  enableTelemetry: false,
  enableRoutingTelemetry: false,
  enableComponentTelemetry: false,
  enableClassTelemetry: false,
  openTelemetry: {
    commonConfig: {
      console: false,
      serviceName: 'spotlight-frontend',
      probabilitySampler: '1',
    },
    otelcolConfig: {
      url: 'http://127.0.0.1:4318/v1/traces',
    },
  },
  appConfig: mergeConfigs(defaultConfig, envConfig),
  defaultConfig,
  appVersion,
  froalaKey: 'hWA2C-7J2C4C3D5D2C1F2wd1DBKSPF1WKTUCQOa1OURPJ1KDe2F-11D2C2D2C2C3A3B2D6D1D1==',
};
